import { useMemo, useState } from 'react'
import { PresimDataType } from '../../../utils/scenario-types'
import usePresimApis from '../../../hooks/usePresimApis'
import useSelectedGroupSatellite from '../../../hooks/useSelectedGroupSatellite'
import useScenarioResponse from '../../../hooks/useScenarioResponse'
import useNavigation from '../../../hooks/useNavigation'
import useForm from '../../../hooks/useForm'
import { showToastMessage } from '../../../../../../utils/commonFunctions'
import { CircularProgress } from '@mui/material'
import { ImportSvg } from '../../../../../CommonComponents/svgs/Svgs';
import { PresimPaneltype } from '../../../utils/scenario-types'


function ThermalUpload({graphs, modalId}: {graphs?: PresimPaneltype[], modalId: string}) {
    const { formData } = useForm()
    const { missionId, scenarioId } = useNavigation()
    const { scenarioResponse } = useScenarioResponse()
    const { selectedGroupSatellite } = useSelectedGroupSatellite()
    const { handleImportThermalTelemetry, uploadThermalZip } = usePresimApis()

    const [isDragging, setIsDragging] = useState(false);
    const [loading, setLoading] = useState<boolean>(false)

    const selectedSatellite = useMemo(() => selectedGroupSatellite?.satelliteId, [selectedGroupSatellite?.satelliteId])
    const presimData = useMemo(() => formData.assets.presim.data, [formData])

    const handleDrop = async (e) => {
        e.preventDefault();
        setIsDragging(false);

        const file = e.dataTransfer.files?.[0];
        if (!file) return;
        setLoading(true)
        const response = await uploadThermalZip(
            file,
            missionId,
            scenarioId!,
            scenarioResponse!,
            presimData as PresimDataType,
            selectedSatellite!
        );
        response.status === "success" ? showToastMessage('success', 'Thermal data imported successfully') : showToastMessage('error', 'Failed to import thermal data');
        setLoading(false)
    };

    const handleImport = async () => {
        setLoading(true)
        try {
            await handleImportThermalTelemetry(missionId, scenarioId!, scenarioResponse!, presimData as PresimDataType, selectedSatellite!)
            showToastMessage('success', 'Thermal data imported successfully')
        } catch (error) {
            showToastMessage('error', 'Failed to import thermal data')
        } finally {
            setLoading(false)
        }
    }

    return (
        <div
            className={`presim__graphs__upload__button__container ${graphs?.length !== 0 ? 'small' : ''}`}
            onDragOver={(e) => {
                e.preventDefault();
                setIsDragging(true);
            }}
            onDragLeave={() => setIsDragging(false)}
            onDrop={handleDrop}
        >
            <button
                className={`presim__graphs__upload__button ${isDragging && 'dragging'}`}
                disabled={loading}
                onClick={handleImport}
            >
                <div className='upload__button__icon'>
                    <ImportSvg />
                </div>
                <div className='upload__button__details'>
                    <span className='upload__button__title'>{loading ? 'Uploading' : 'Upload Data'} {loading && <CircularProgress size={16} color='inherit' />}</span>
                    <span className='upload__button__description'>Upload thermal data from desktop Application </span>
                </div>
            </button>
        </div>
    );
}

export default ThermalUpload;
